import { IconButton } from '@mui/material';
import {
    CTableWrapper,
    DBlock,
    DPage,
    DPageBody,
    EditIcon,
} from '../../../../dum';
import { UsersPageQuery, useUsersPageQuery } from '../../../../../services';
import { useState } from 'react';
import { SUpsertUserDialog } from '../../../../smart';

export function UsersPage() {
    const { data, loading } = useUsersPageQuery();
    const [upsertOpen, setUpsertOpen] = useState(false);
    const [userId, setUserId] = useState<number | null>(null);

    const users: UsersPageQuery['users'] = data?.users || [];

    // The forced-password-reset action lives inside the user dialog now (a
    // super-user-only checkbox in the General tab), so the page itself no longer
    // carries a reset button or its confirmation modal.
    return (
        <DPage>
            <DPageBody>
                <DBlock>
                    <CTableWrapper
                        items={[
                            {
                                cellGrow: 10,
                                title: 'Nombre',
                                content: (user) =>
                                    user.is_root
                                        ? `${user.fullname} (root)`
                                        : user.fullname,
                            },
                            {
                                cellGrow: 10,
                                title: 'Roles',
                                content: (user) =>
                                    user.roles
                                        .map((role) => role.name)
                                        .join(', '),
                            },
                            {
                                title: 'MFA',
                                content: (user) =>
                                    user.mfa_enabled ? 'Sí' : 'No',
                            },
                            {
                                title: 'Acceso',
                                content: (user) =>
                                    user.login_disabled
                                        ? 'Deshabilitado'
                                        : 'Activo',
                            },
                            {
                                title: '',
                                content: (user) => (
                                    <IconButton
                                        size="small"
                                        sx={{
                                            bgcolor: 'rgba(34,197,94,0.15)',
                                            boxShadow: 2,
                                            borderRadius: '50%',
                                        }}
                                        onClick={() => {
                                            setUpsertOpen(true);
                                            setUserId(user.id);
                                        }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                ),
                            },
                        ]}
                        data={users}
                        loading={loading}
                    />
                </DBlock>
            </DPageBody>
            <SUpsertUserDialog
                open={upsertOpen}
                setOpen={setUpsertOpen}
                userId={userId}
            />
        </DPage>
    );
}
